import React from 'react';
import EstimateSettings from 'containers/settings/EstimateSettings';

const EstimateSettingsPage = () => {
  return <EstimateSettings />;
};

export default EstimateSettingsPage;
